@if (this['input'] != 'embryo_grading_format' && this['input'] != 'embryo_summary' &&!utilService.isMobile()) {
    <div class="d-flex flex-column">
      <div class="d-flex justify-content-between align-items-end w-100 mb-2">
        @if(patient_protocol)
        {
        <div class="d-flex flex-column" style="gap: 6px;">
          <div class="d-flex align-items-center flex-wrap" style="gap: 16px;">
            @if(patient_protocol && patient_protocol_info?.protocol_name){
              <div class="d-flex align-items-center">
                
                <span style="font-size: 15px; font-weight: 500; color: #333;">{{patient_protocol_info?.protocol_name}}</span>
              </div>
            }
            @if(patient_protocol && patient_protocol_info?.intent){
              <div class="d-flex align-items-center">
                <span class="text-muted font-weight-bold mr-2" style="font-size: 14px; text-transform: capitalize;">Intent:</span>
                <span style="font-size: 14px; font-weight: 500; color: #333;">{{patient_protocol_info.intent}}</span>
              </div>
            }
          </div>
          @if(patient_protocol && patient_protocol_info?.protocol_remark){
            <div class="d-flex align-items-center">
              <span class="text-muted font-weight-bold mr-2" style="font-size: 14px; text-transform: capitalize;">Protocol remark:</span>
              <span style="font-size: 14px; font-weight: 500; color: #333;">{{patient_protocol_info.protocol_remark}}</span>
            </div>
          }
        </div>
        }
      <!-- Pagination Controls -->
      <div class="pagination-controls ml-auto">
        @if (this['input'] !== 'embryo_grading_format' && this['input'] !== 'embryo_summary'&&apiData
        &&this.apiData.length>0 && !this['historyPopup']) {
        @if (cycleStatus) {
        <span class="font-weight-bold">{{cycleStatus}}</span>
        }
        @if (!isorderBtnVisible && !from_History && !pullableView) {
          <button class="btn btn-primary btn-sm mx-2" (click)="handlePrint()">{{'Print'}}</button>
          }
        @if (isorderBtnVisible && !from_History && !pullableView) {
        <button class="btn btn-primary btn-sm mx-2" (click)="orderMedication()">{{'button.order_service' | translate | async}}</button>
        }
        @if (isStopBtnVisible && !from_History && !pullableView) {
        <button class="btn btn-primary btn-sm" (click)="handleClose()">{{patient_protocol?"Deactivate Protocol":"Close"}}</button>
        }
        }
        <button (click)="prevPage(currentPageStart)" [disabled]="isPrevDisabled">&lt;</button>
        <span>{{ currentPageStart }} - {{ currentPageEnd }} / {{ totalItems }}</span>
        <button (click)="nextPage(currentPageEnd)" [disabled]="isNextDisabled">&gt;</button>
      </div>
      </div>
      <!-- Stimulation Chart Grid -->
      @if (gridData?.stimulationData) {
      <div class="stimulation_chart grid-action-display-none" [ngClass] ="patient_protocol?'header-display-none patient_protocol':''">
        <dhs-data-grid (editEllipseClick)="changeStimulationDate($event)" [data]="gridData.stimulationData" [fields]="fieldsStimulation" [config]="gridConfig" [rowClick]="rowClick">
        </dhs-data-grid>
      </div>
      }
      <!-- Clinical Data Grid -->
      @if (gridData?.clinicalData){
      <div class="box clinical_view stimulation_chart header-display-none grid-action-display-none" [ngClass]="patient_protocol ? 'header-display-none' : ''">
        <div class="heading d-flex">
          <div>Clinical order <span class="text-danger">*</span></div>
          @if (!viewOnly && !pullableView && apiData?.length>0) {
          <button class="plus-button ml-auto" (click)="clinicalForm()">+</button>
          }
        </div>
        <dhs-data-grid [data]="gridData.clinicalData" [fields]="fieldsClinical" [config]="gridConfig"
          (editEllipseClick)="buttonActionClinical($event)" (bindGrid)="bindDataToGrid($event)">
        </dhs-data-grid>
      </div>
      }
      <!-- Medication Data Grid -->
      @if (gridData?.medicationData) {
      <div class="box medication_view stimulation_chart grid-action-display-none" [ngClass]="patient_protocol ? 'patient_protocol' : ''">
        <div class="heading d-flex justify-content-between">
          <div>Medication order <span class="text-danger">*</span></div>
          @if (!viewOnly) {
          <div class="d-flex justify-content-center align-items-center">
            @if (gridData.medicationData?.barcodeConfig?.performActionOnScan) {
            <button type="button" (click)="toggleBarcode('medicationData')"
              [ngClass]="(gridData.medicationData?.barcodeConfig?.barcodeScan == true) ? 'btn-with-icon-label-round-back' : 'btn-with-icon-label'">
              <div>
                <div>
                  <i aria-hidden="true" class="fa fa-barcode"></i>
                </div>
                <span>{{'Scan' | translate | async}}</span>
              </div>
            </button>
            }
            @if(apiData?.length>0){
            <button class="plus-button ml-auto" (click)="medicationForm()">+</button>
            }
          </div>
          }
        </div>
      @if (fieldsMedication) {
        <dhs-data-grid (editEllipseClick)="buttonAction($event)" [data]="gridData.medicationData"
          [fields]="fieldsMedication" [config]="gridConfig" (bindGrid)="bindDataToGrid($event)">
        </dhs-data-grid>
      }
      </div>
      }

      <!-- Surgery Add Btn -->
      @if (!viewOnly && !pullableView && patient_protocol) {
      <div class="heading d-flex pr-4">
        <div class="ml-auto pr-2" (click)="addSurgery()">Add Surgery</div>
        <button class="plus-button" style="margin-top: 2px;" (click)="addSurgery()">+</button>
      </div>
      }
      <!-- Surgery Data Grid -->
      @if (!patient_protocol ) {
       <div class="box surgery_view stimulation_chart grid-action-display-none header-display-none pb-3">
          <div class="heading d-flex">
          <div>Surgery Order <span class="text-danger">*</span></div>
         @if (!viewOnly && !pullableView && apiData?.length>0) {
         <button class="plus-button ml-auto" (click)="addSurgery()">+</button>
        }
       </div>
      @if ( gridData?.surgeryGridData && gridData.surgeryGridData.resource?.length) {
      <dhs-data-grid [data]="gridData.surgeryGridData" [fields]="fieldsSurgery" [config]="gridConfig">
      </dhs-data-grid>
      }
    </div>
    }
      <!-- Stimulation Chart Grid -->
      @if (gridData?.remarkMarkDoneBtnData && patient_protocol) {
      <div class="stimulation_chart grid-action-display-none header-display-none">
        <dhs-data-grid [data]="gridData.remarksTableData" [fields]="fieldsStimulation" [config]="gridConfig" [rowClick]="rowClick">
        </dhs-data-grid>
      </div>
      }
       <!-- Clinical Data Grid -->
      @if (gridData?.remarkMarkDoneBtnData && patient_protocol && !from_History) {
        <!-- 1234567890-\ -->
         <!-- {{gridData | json}} -->
      <div class=" stimulation_chart header-display-none grid-action-display-none">
        <dhs-data-grid [data]="gridData.remarkMarkDoneBtnData" [fields]="fields" [config]="gridConfig"
          (editEllipseClick)="remarkMarkDoneBtnData($event)" [rowClick]="rowClick">
        </dhs-data-grid>
      </div>
      }
    </div>
    }
    @if (this['input'] == 'embryo_grading_format') {
    <div class="w-100">
      <!-- Clinical Data Grid -->
       @if (!this['historyPopup']){
      <div class="box clinical_view stimulation_chart">
        <div class="heading d-flex">
          <div>Clinical order <span class="text-danger">*</span></div>
          @if (!viewOnly) {
          <button class="plus-button ml-auto" (click)="clinicalForm('grading')">+</button>
          }
        </div>
      </div>
     }
       @if (embryoResourceDef && embryoResourceDef.form && !viewOnly && apiData && activeTab === jsonResource && !this['historyPopup']) {
    <dhs-form #formComponenet
      [fieldGroup]="embryoResourceDef.form" [config]="embryoResourceDef.config" [data]="editableGridData?.[0]"
      [action]="(!btnHide && !viewOnly && editableGridData?.length>0)?'ADD':'VIEW'"
      (questionValueChanged)="questionValueChanged($event)">
    </dhs-form>
    }
      @if (this['input'] == 'embryo_grading_format'&&grading_data && !this['historyPopup']) {
      <div class="pagination-controls text-right mr-2">
        @if (cycleStatus) {
        <span class="font-weight-bold">{{cycleStatus}}</span>
        }
        @if (!isorderBtnVisible && !from_History && !pullableView) {
          <button class="btn btn-primary btn-sm mx-2" (click)="handlePrint()">{{'Print'}}</button>
          }
        @if (isStopBtnVisible&&!from_History) {
        <button class="btn btn-primary btn-sm" (click)="handleClose()">Close</button>
        }
       
      </div>
      }
      <div class="main-content-container">
        <div class="layout_tab_horizontal">
          <ul class="base-tab tabWithoutButtons">
            @for (a of daysCount; track a; let i = $index) {
            <li class="nav-item" style="min-width: 150px;text-align: center;">
              <a class="nav-link" id="nav-consultation-tab" [ngClass]="activeTab == ('grading_days'+i) ? 'active': ''"
                data-toggle="tab" (click)="hasActiveTab(('grading_days'+i))">{{a}}</a>
            </li>
            }
          </ul>
          @if (activeTab == jsonResource && this.apiData) {
          <dhs-editable-grid  [config]="{'items':this.apiData}"  [resource]="jsonResource" (listen_changes)="daysEdit($event)" [json]="medication_update_json"
            [class.grading-day0-grid]="jsonResource == 'grading_days0'">
          </dhs-editable-grid>
          }
        </div>
      </div>
      @if (!btnHide && !viewOnly && editableGridData?.length>0) {
      <div class="d-flex w-100 justify-content-center p-3">
        <button class="secondary-btn mt-2" (click)="onSaveFinished('draft')">Draft <i class="fa fa-plus-square"
            aria-hidden="true"></i></button>
        <button class="primary-btn mt-2" (click)="onSaveFinished('final')">Final <i class="fa fa-floppy-o text-white"
            aria-hidden="true"></i></button>
        @if(activeTab != 'grading_days7'){
        <button class="secondary-btn mt-2" (click)="skipdays('today')">Skip Today <i class="arrow-resize fa fa-angle-right"
            aria-hidden="true"></i></button>
        <button class="secondary-btn mt-2" (click)="onSaveFinished('skip_next')">Skip Next Visit <i
            class="arrow-resize fa fa-angle-double-right" aria-hidden="true"></i></button>
        }
      </div>
      }
    </div>
    }
    @if (gridData.embryoSummary) {
    <div class="w-100">
      <div class="d-flex flex-row-reverse">
        <button type="button" class="btn-with-icon-label" (click)="handlePrint()"><i class="fa fa-print"></i><span> Print </span></button>
      </div>
      <dhs-data-grid [data]="gridData.embryoSummaryData" [fields]="gridData.embryoSummaryField" [config]="gridSummaryConfig">
      </dhs-data-grid>
    </div>
    }
    <!-- MOBILE VIEW for stimulation & ET monitoring -->
    
    @if (this['input'] != 'embryo_grading_format' && this['input'] != 'embryo_summary' &&utilService.isMobile()) {
    <div class="mobile-action-bar" *ngIf="!from_History && !viewOnly && !pullableView">
    
      <button class="action-btn btn-medication" (click)="medicationForm()">
        <i class="fa fa-plus"></i>
        <span>Medication</span>
      </button>
    
      <button class="action-btn btn-clinical" (click)="clinicalForm()">
        <i class="fa fa-plus"></i>
        <span>Clinical</span>
      </button>
    
      <button class="action-btn btn-surgery" (click)="addSurgery()">
        <i class="fa fa-plus"></i>
        <span>Surgery</span>
      </button>
    
      <!-- <button class="action-btn btn-scan" (click)="toggleBarcode('medicationData')">
          <i class="fa fa-barcode"></i>
          <span>Scan</span>
        </button> -->
      @if (!viewOnly && gridData?.medicationData?.barcodeConfig?.performActionOnScan) {
      <button type="button" class="action-btn" (click)="toggleBarcode('medicationData')" [ngClass]="gridData.medicationData?.barcodeConfig?.barcodeScan 
                             ? 'btn-scan-active action-btn btn-with-icon-label-round-back-mobile' 
                             : 'btn-scan action-btn'">
    
        <i class="fa fa-barcode"></i>
        <span>Scan</span>
    
      </button>
      }
      @if (!isorderBtnVisible && !from_History && !pullableView) {
        <button class="btn btn-primary btn-sm mx-2" (click)="handlePrint()">{{'Print'}}</button>
        }
      <button *ngIf="isStopBtnVisible  && !from_History && !pullableView" class="action-btn btn-close-chart" (click)="handleClose()">
        <i class="fa fa-times"></i>
        <span>{{patient_protocol?"Deactivate Protocol":"Close"}}</span>
      </button>
      
    </div>
    <div class="mobile-daywise-container">
    
      <div *ngFor="let day of dayWiseCards; trackBy: trackByDay" class="day-card">
    
        <!-- HEADER -->
        <div class="day-header">
          <div class="day-badge">{{ day.day }}</div>
          <div class="day-date">{{ day.stimulationDate || '-' }}</div>
        </div>
    
        <!-- STIMULATION -->
        <div class="info-grid">
          <div class="info-item">
            <span class="label">Menses Date</span>
            <span class="value">{{ day.menses || '-' }}</span>
          </div>
    
          <div class="info-item">
            <span class="label">Stimulation Date</span>
            <span class="value">{{ day.stimulationDate || '-' }}</span>
          </div>
    
          <div class="info-item">
            <span class="label">Surgery Date</span>
            <span class="value">{{ day.surgeryDate ? day.surgeryDate : '-' }}</span>
          </div>
        </div>
    
        <!-- CLINICAL -->
        <div class="medication-container">
          <div class="medication-title">Clinical Order</div>
          <ng-container *ngIf="day.clinical?.length; else noClinical">
            <div class="clinical-list">
              <div *ngFor="let c of day.clinical" class="clinical-row">
                <!-- <div class="clinical-name">
                  {{ c.name }}
                </div> -->
                <div class="clinical-name d-flex align-items-center justify-content-between">
    
                  <!-- NAME -->
                  <span>
                    {{ c.name }}
                  </span>
    
                  <!-- CHART ICON (CONDITION BASED) -->
                  <div class="d-flex">
                    <button *ngIf="c?.hasFolliculogram"
                      (click)="buttonActionClinical({actionType:{action:'open_follicle_chart'},data:c})"
                      class="btn  btn-primary ms-1 p-1 btn-sm">
                      <i class="fa fa-line-chart cursor-pointer">
                      </i>
                    </button>
                  </div>
                </div>
                <!-- <div class="clinical-value">
                  {{ c.value || '-' }}
                </div> -->
    
    
                <div class="d-flex align-items-start">
                  <img *ngIf="getStatusIcon(c.value)" [src]="getStatusIcon(c.value)" class="new-source-icon-design"
                    width="18" />
    
    
                  <span *ngIf="!getStatusIcon(c.value)" class="fw-semibold">
                    {{ c.value }}
                  </span>
                  <div class="d-flex">
                    <button *ngIf="c?.hasFolliculogram && (c?.value === 'Given' || c?.value === 'Completed')"
                      (click)="buttonActionClinical({actionType:{action:'open_follicle_data',params:{'day_no':c.day_no}},data:c})"
                      class="btn  btn-primary ms-1 p-1 btn-sm">
                      <i class="fa fa-table   cursor-pointer">
                      </i>
                    </button>
                  </div>
                </div>
    
                <!-- GTV, CTV, PTV details -->
                <div class="row small mt-1 pl-3 w-100" *ngIf="isRadiationTherapy && (c.GTV || c.CTV || c.PTV)">
                  <div *ngIf="c.GTV" class="col-4 p-0">
                    <span class="text-muted">GTV:</span> {{ c.GTV }}
                  </div>
                  <div *ngIf="c.CTV" class="col-4 p-0">
                    <span class="text-muted">CTV:</span> {{ c.CTV }}
                  </div>
                  <div *ngIf="c.PTV" class="col-4 p-0">
                    <span class="text-muted">PTV:</span> {{ c.PTV }}
                  </div>
                </div>
    
              </div>
            </div>
          </ng-container>
          <ng-template #noClinical>
            <div class="empty-state">No clinical data available</div>
          </ng-template>
        </div>
    
    
        <div class="medication-container">
    
          <div class="medication-title">Medication Order</div>
          <ng-container *ngIf="day.medication?.length; else noMedication">
            <div *ngFor="let m of day.medication" class="position-relative border-bottom py-2">
    
              <div class="d-flex justify-content-between align-items-center">
    
                <!-- LEFT CONTENT -->
                <div class="flex-grow-1 pe-2">
                  <div class="fw-semibold d-flex align-items-center mb-1">
    
                    <img *ngIf="!m.hide && m?.otherData?.itemFlag" src="assets/images/emr/triangle-risk-icon.svg" width="18"
                      #infoPopover1="bs-popover" [popover]="getFlagString(m?.otherData?.itemFlag)" placement="top"
                      container="body" [outsideClick]="true" triggers="" (click)="openFlagPopover(infoPopover1,$event)">
    
                    <span *ngIf="!m.hide">{{ m.name }}</span>
                  </div>
    
                  <div class="row small">
                    <div class="col-6">
                      <span class="text-muted">Time:</span> {{ m.time }}
                    </div>
    
                    <div class="col-6">
                      <span class="text-muted">Dosage No:</span>
                      {{ m.otherData?.dosage_no || m.dose }}
                    </div>
    
                    <div class="col-6">
                      <span class="text-muted">Dosage Form:</span>
                      {{ m.otherData?.dosage_form || '-' }}
                    </div>
    
                    <!--  STATUS BLOCK -->
                      <div class="col-6">
                      <div class="d-flex align-items-center">
    
                        <span class="text-muted me-2">Status:</span>
    
                        <!--  STATUS CLICK (POPOVER) -->
                        <div class="d-flex align-items-center cursor-pointer" #statusMenu="bs-popover"
                          [popover]="getStatusActions(m)?.length ? statusMenuTemplate : null" [popoverContext]="{ item: m }"
                          placement="auto" container="body" triggers="manual" [outsideClick]="true"
                          containerClass="mobile-three-dot-popover" (click)="handleStatusPopover(statusMenu, $event)">
    
                          <img *ngIf="getStatusIcon(m.status)" [src]="getStatusIcon(m.status)" width="18" class="me-1" />
    
                          <span *ngIf="!getStatusIcon(m.status)">
                            {{ m.status }}
                          </span>
    
                        </div>
    
                        <!-- INFO ICON (KEEP AS IT IS ) -->
                        <!-- <i *ngIf="(m.status === 'Given' || m.status === 'Completed')&&input!='et_monitoring_chart' && !viewOnly && !from_History"
                          class="fa fa-info-circle " #infoPopover="bs-popover" [popover]="infoTemplate" placement="top"
                          container="body" triggers="mouseenter:mouseleave" [popoverContext]="{ m: m }"
                          (click)="$event.stopPropagation()">
                        </i> -->
                        <i *ngIf="(m.status === 'Given' || m.status === 'Completed')
                                && input!='et_monitoring_chart'
                                && !viewOnly
                                && !from_History" class="fa fa-info-circle" #infoPopoverStatus="bs-popover"
                          [popover]="infoTemplateStatus" [popoverContext]="{m:m}" placement="top" container="body"
                          triggers="click" [outsideClick]="true" (click)="openStatusPopover(infoPopoverStatus,$event)">
                        </i>
    
                      </div>
                    </div>
                  </div>
                </div>
    
                <!-- THREE DOT -->
                <div class="position-relative" *ngIf="!viewOnly && !from_History&& input!='et_monitoring_chart' ">
                  <i class="fa fa-ellipsis-v px-2" #menu="bs-popover" [popover]="actionMenuTemplate"
                    [popoverContext]="{ item: m }" placement="left top" triggers="" [outsideClick]="true" container="body"
                    containerClass="mobile-three-dot-popover"
                    (click)="$event.stopPropagation();handleMenuPopover(menu, $event)">
                  </i>
    
                </div>
    
              </div>
            </div>
          </ng-container>
          <ng-template #noMedication>
            <div class="empty-state">No medication prescribed</div>
          </ng-template>
        </div>
      </div>
      @if (!patient_protocol && gridData?.surgeryGridData?.resource?.length) {
        <div class="day-card surgery-card">
          <div class="day-header" style="border-left: 4px solid #26a69a;">
            <div class="day-badge" style="background: #26a69a; color: white;">Surgery Orders</div>
          </div>
          <div class="medication-container" style="margin-top: 0px;">
            <div class="clinical-list">
              <div *ngFor="let s of gridData.surgeryGridData.resource"
                class="clinical-row d-flex flex-column align-items-start border-bottom py-2"
                style="gap: 4px; background: transparent;">
                <div class="clinical-name font-weight-bold" style="font-size: 14px;">{{ s.name }}</div>
                <div class="d-flex flex-column pl-2" style="font-size: 12px; color: #666; gap: 2px;">
                  <div *ngFor="let date of s.dates" class="d-flex align-items-center">
                    <i class="fa fa-calendar mr-1" style="color: #1976d2;"></i>
                    <span>{{ date }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
      
    </div>
    <ng-template #infoTemplateStatus let-m="m">
      <div>
        <b>Administered By:</b> {{ m?.otherData?.administeredBy || '-' }}
        <br />
        <b>Date Time:</b>
        {{ m?.administeredTime ? (m?.otherData?.administer_time | date:'short') : '-' }}
      </div>
    </ng-template>
    <ng-template #flagTemplate let-flags="flags">
      <div *ngIf="flags.length">
    
        {{ getFlagString(flags)}}
      </div>
    </ng-template>
    <ng-template #actionMenuTemplate let-item="item">
    
      <button *ngFor="let a of getMobileActions(item)" class="p-dropdown-item" (click)="executeCapability(a, item)">
        {{ a.label | translate | async }}
      </button>
    
    </ng-template>
    <ng-template #statusMenuTemplate let-item="item">
      <button *ngFor="let a of getStatusActions(item)" class="p-dropdown-item"
        (click)="executeCapability(a, item['itemData']['id'+item.dayIndex])">
        {{ a.label | translate | async }}
      </button>
    </ng-template>
    }